import React from "react";
import "../styles/HeroSection.desktop.css";
import "../styles/HeroSection.mobile.css";
import carImg from "../assets/images/Group 4.png";
import mobileBg from "../assets/images/mobile.png"; // <-- your mobile bg
import GeneralHeader from "./GeneralHeader";
import Footer from "./Footer";
import MobileBrandLogos from "./MobileBrandLogos";
import MobileFooterSheet from "./MobileFooterSheet";
import Swal from "sweetalert2";

export default function HeroSection({ currentView, setCurrentView }) {
  return (
    <div
      className="hero-section text-white px-5"
      dir="rtl"
      style={{ "--hero-mobile-bg": `url(${mobileBg})` }}
    >
      {/* Background clip / spotlight (desktop only) */}
      <div className="clip-bg desktop-only" />

      {/* Header */}
      <div className="hero-header">
        <GeneralHeader currentView={currentView} setCurrentView={setCurrentView} />
      </div>
      {/* ================= Desktop content (unchanged) ================= */}
      <div className="hero-desktop text-center my-4">
        <h1 className="hero-title">كل قطع الغيار اللي تحتاجها لسيارتك</h1>

        <img src={carImg} alt="Car" className="car-img" />

        <div className="d-flex justify-content-between text-start mt-4">
          <ul className="left">
            <li>توصل لين عندك</li>
            <li>مستخدمة نظيفة</li>
          </ul>
          <ul className="right">
            <li>أصلية وكالة</li>
            <li>بنصف السعر</li>
          </ul>
        </div>

        <div className="d-flex justify-content-center gap-3 mb-4 buttons">
          <button
            className="btn btn-yellow px-4"
            onClick={() => setCurrentView && setCurrentView("brands")}
          >
            بطلب بنفسي
          </button>

          <button
            className="btn btn-outline-yellow px-4"
            onClick={() => {
              const token = localStorage.getItem("token");
              if (!token) {
                Swal.fire({
                  icon: "warning",
                  title: "⚠️ يجب أن تسجل دخول أولاً",
                  confirmButtonText: "حسناً",
                  confirmButtonColor: "#CAEA3E",
                  iconColor: "#CAEA3E",
                  customClass: {
                    popup: "swal-dark-popup",
                    confirmButton: "swal-confirm-btn",
                  },
                }).then(() => {
                  setCurrentView && setCurrentView("login");
                });
                return;
              }
              setCurrentView && setCurrentView("chat");
            }}
          >
            أحتاج مساعدة
          </button>
        </div>
      </div>

      {/* ================= Mobile content (new) ================= */}
      <div className="hero-mobile">
        {/* Headline + bullets */}
        <p className="m-hero-title">كل قطع الغيار اللي تحتاجها لسيارتك</p>

        <div className="m-bullets">
          <div className="m-bullet"><i className="bi bi-check2-circle" /> أصلية وكالة</div>
          <div className="m-bullet"><i className="bi bi-check2-circle" /> بنصف السعر</div>
          <div className="m-bullet"><i className="bi bi-check2-circle" /> مستخدمة نظيفة</div>
          <div className="m-bullet"><i className="bi bi-check2-circle" /> توصل لين عندك</div>
        </div>

        {/* CTAs (stacked) */}
        <div className="m-cta">
          <button
            className="m-btn m-btn-primary"
            onClick={() => setCurrentView && setCurrentView("brands")}
          >
            بطلب بنفسي
          </button>
          <button
            className="m-btn m-btn-outline"
            onClick={() => {
              const token = localStorage.getItem("token");
              if (!token) {
                Swal.fire({
                  icon: "warning",
                  title: "⚠️ يجب أن تسجل دخول أولاً",
                  confirmButtonText: "حسناً",
                  confirmButtonColor: "#CAEA3E",
                  iconColor: "#CAEA3E",
                  customClass: {
                    popup: "swal-dark-popup",
                    confirmButton: "swal-confirm-btn",
                  },
                }).then(() => {
                  setCurrentView && setCurrentView("login");
                });
                return;
              }
              setCurrentView && setCurrentView("chat");
            }}
          >
            أحتاج مساعدة
          </button>
        </div>

        {/* Brand logos strip */}
        <MobileBrandLogos />
      </div>

      {/* Desktop footer stays; mobile footer is a bottom-sheet */}
      <div className="desktop-only" style={{ position: "absolute", zIndex: 2, top: "84%", left: "12%" }}>
        <Footer setCurrentView={setCurrentView} />
      </div>

      {/* Peekable bottom sheet (mobile only) */}
      <div className="hero-footer">
        <MobileFooterSheet mode="sticky" />
      </div>

    </div>
  );
}
